export function IconPlus({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        d="M448 224H288V64h-64v160H64v64h160v160h64V288h160z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconTimes({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z"
      />
    </svg>
  );
}

export function IconSave({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M380.93 57.37A32 32 0 0 0 358.3 48H94.22A46.21 46.21 0 0 0 48 94.22v323.56A46.21 46.21 0 0 0 94.22 464h323.56A46.36 46.36 0 0 0 464 417.78V153.7a32 32 0 0 0-9.37-22.63ZM256 416a64 64 0 1 1 64-64a63.92 63.92 0 0 1-64 64Zm48-224H112a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16v64a16 16 0 0 1-16 16Z"
      />
    </svg>
  );
}

export function IconUser({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M8 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0a2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1s1-4 6-4s6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664h10Z"
      />
    </svg>
  );
}

export function IconUserPlus({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96Z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M288 304c-87 0-175.3 48-191.64 138.6c-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304Z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M88 176v112m56-56H32"
      />
    </svg>
  );
}

export function IconKey({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M218.1 167.17c0 13 0 25.6 4.1 37.4c-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 0 0-6.7 15c0 8.5 5.2 16.7 9.6 21.3c6.6 6.9 34.8 33 40 28c15.4-15 18.5-19 24.8-25.2c9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4s15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2c5-4.6 8.6-8.9 8.7-15.6c.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5s22.8-15.5 24.1-21.6s-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4c15.5 6.7 29.6 9.4 47.7 9.4c68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17ZM400 144a32 32 0 1 1-32-32a32 32 0 0 1 32 32Z"
      />
    </svg>
  );
}

export function IconClose({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M368 368L144 144m224 0L144 368"
      />
    </svg>
  );
}

export function IconCheck({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M416 128L192 384l-96-96"
      />
    </svg>
  );
}

export function IconTrash({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="m112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M80 112h352"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M192 112V72h0a23.93 23.93 0 0 1 24-24h80a23.93 23.93 0 0 1 24 24h0v40m-64 64v224m-72-224l8 224m136-224l-8 224"
      />
    </svg>
  );
}

export function IconEdit({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        d="M163 439.573l-90.569-90.569L322.78 98.656l90.57 90.569z"
        fill="currentColor"
      />
      <path
        d="M471.723 88.393l-48.115-48.114c-11.723-11.724-31.558-10.896-44.304 1.85l-45.202 45.203 90.569 90.568 45.202-45.202c12.743-12.746 13.572-32.582 1.85-44.305z"
        fill="currentColor"
      />
      <path d="M64.021 363.252L32 480l116.737-32.021z" fill="currentColor" />
    </svg>
  );
}

export function IconPdf({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24">
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v14H5V5h14m-1.1 8.5c-.3-.5-1-.7-2.2-.7c-.4 0-.8 0-1.2.1c-.3-.2-.6-.4-.8-.6c-.6-.5-1.2-1.4-1.5-2.5v-.1c.3-1.3.6-2.8 0-3.5c-.3-.1-.5-.2-.7-.2h-.2c-.4 0-.7.4-.8.7c-.4 1.3-.1 2 .2 3.2c-.2.9-.6 1.8-1 2.8c-.4.7-.7 1.3-1 1.8c-.4.2-.7.3-.9.5c-1.1.7-1.7 1.5-1.8 2v.5l.5.3c.2.2.3.2.5.2c.8 0 1.7-.9 2.9-3h.1c1-.3 2.2-.5 3.9-.7c1 .5 2.2.7 2.9.7c.4 0 .7-.1.9-.3c.2-.2.3-.4.3-.6c0-.3 0-.5-.1-.6M6.8 17.3c0-.4.5-1 1.2-1.6c.1-.1.3-.2.5-.3c-.7 1.1-1.3 1.8-1.7 1.9m4.5-10.6s0-.1.1-.1h.1c.2.2.2.5.1 1.1v.2c-.1.2-.1.5-.2.8c-.3-.9-.3-1.6-.1-2m-1.2 7.6H10c.1-.3.3-.6.5-1c.4-.8.8-1.6 1-2.3c.4.9.9 1.6 1.5 2.1c.1.1.3.2.4.3c-.9.1-2.1.4-3.3.9m7.2-.1h-.2c-.4 0-1.1-.2-1.8-.5c.1-.1.2-.1.2-.1c1.4 0 1.7.2 1.8.3l.1.1c0 .2 0 .2-.1.2z"
        fill="currentColor"
      />
    </svg>
  );
}
export function IconArrowUp({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconArrowBottom({ className = "w-5" }) {
  return (
    <svg
      className={`${className}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 6"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 1 4 4 4-4"
      />
    </svg>
  );
}

export function IconFilterSetting({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15 22h2v2h-2m-4-2h2v2h-2m-4-2h2v2H7m8-4.12c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L9.29 16.7a.989.989 0 0 1-.29-.83v-5.12L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L15 10.75v9.13M7.04 5L11 10.06v5.52l2 2v-7.53L16.96 5Z"
      />
    </svg>
  );
}

export function IconDataBase({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24">
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M4 6v6s0 3 7 3s7-3 7-3V6" />
        <path d="M11 3c7 0 7 3 7 3s0 3-7 3s-7-3-7-3s0-3 7-3Zm0 18c-7 0-7-3-7-3v-6m15 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4Z" />
        <path strokeDasharray=".3 2" d="M19 22a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z" />
      </g>
    </svg>
  );
}

export function IconFileClip({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M208 64h66.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62V432a48 48 0 0 1-48 48H192a48 48 0 0 1-48-48V304"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M288 72v120a32 32 0 0 0 32 32h120"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M160 80v152a23.69 23.69 0 0 1-24 24c-12 0-24-9.1-24-24V88c0-30.59 16.57-56 48-56s48 24.8 48 55.38v138.75c0 43-27.82 77.87-72 77.87s-72-34.86-72-77.87V144"
      />
    </svg>
  );
}

export function IconSignOut({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        d="M312 372c-7.7 0-14 6.3-14 14 0 9.9-8.1 18-18 18H94c-9.9 0-18-8.1-18-18V126c0-9.9 8.1-18 18-18h186c9.9 0 18 8.1 18 18 0 7.7 6.3 14 14 14s14-6.3 14-14c0-25.4-20.6-46-46-46H94c-25.4 0-46 20.6-46 46v260c0 25.4 20.6 46 46 46h186c25.4 0 46-20.6 46-46 0-7.7-6.3-14-14-14z"
        fill="currentColor"
      />
      <path
        d="M372.9 158.1c-2.6-2.6-6.1-4.1-9.9-4.1-3.7 0-7.3 1.4-9.9 4.1-5.5 5.5-5.5 14.3 0 19.8l65.2 64.2H162c-7.7 0-14 6.3-14 14s6.3 14 14 14h256.6L355 334.2c-5.4 5.4-5.4 14.3 0 19.8l.1.1c2.7 2.5 6.2 3.9 9.8 3.9 3.8 0 7.3-1.4 9.9-4.1l82.6-82.4c4.3-4.3 6.5-9.3 6.5-14.7 0-5.3-2.3-10.3-6.5-14.5l-84.5-84.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconDollar({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480Zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53c0 22.3 16.39 36.88 47.27 43.47Zm32 78v92c38.15-1.54 56.38-18.92 56.38-45.77c0-24.58-18.23-41.13-56.38-46.23Z"
      />
    </svg>
  );
}

export function IconBell({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M427.68 351.43C402 320 383.87 304 383.87 217.35C383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53c-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43C73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57ZM320 384v16a64 64 0 0 1-128 0v-16"
      />
    </svg>
  );
}

export function IconEarth({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        d="M256 48h-.7c-55.4.2-107.4 21.9-146.6 61.1C69.6 148.4 48 200.5 48 256s21.6 107.6 60.8 146.9c39.1 39.2 91.2 60.9 146.6 61.1h.7c114.7 0 208-93.3 208-208S370.7 48 256 48zm180.2 194h-77.6c-.9-26.7-4.2-52.2-9.8-76.2 17.1-5.5 33.7-12.5 49.7-21 22 28.2 35 61.6 37.7 97.2zM242 242h-61.8c.8-24.5 3.8-47.7 8.8-69.1 17.4 3.9 35.1 6.3 53 7.1v62zm0 28v61.9c-17.8.8-35.6 3.2-53 7.1-5-21.4-8-44.6-8.8-69H242zm28 0h61.3c-.8 24.4-3.8 47.6-8.8 68.9-17.2-3.9-34.8-6.2-52.5-7V270zm0-28v-62c17.8-.8 35.4-3.2 52.5-7 5 21.4 8 44.5 8.8 69H270zm109.4-117.9c-12.3 6.1-25 11.3-38 15.5-7.1-21.4-16.1-39.9-26.5-54.5 24 8.3 45.9 21.6 64.5 39zM315 146.8c-14.7 3.2-29.8 5.2-45 6V79.4c17 9.2 33.6 33.9 45 67.4zM242 79v73.7c-15.4-.8-30.6-2.8-45.5-6.1 11.6-33.8 28.4-58.5 45.5-67.6zm-45.6 6.4c-10.3 14.5-19.2 32.9-26.3 54.1-12.8-4.2-25.4-9.4-37.5-15.4 18.4-17.3 40.1-30.5 63.8-38.7zm-82.9 59.5c15.8 8.4 32.3 15.4 49.2 20.8-5.7 23.9-9 49.5-9.8 76.2h-77c2.6-35.4 15.6-68.8 37.6-97zM75.8 270h77c.9 26.7 4.2 52.3 9.8 76.2-16.9 5.5-33.4 12.5-49.2 20.8-21.9-28.1-34.9-61.5-37.6-97zm56.7 117.9c12.1-6 24.7-11.2 37.6-15.4 7.1 21.3 16 39.6 26.3 54.2-23.7-8.4-45.4-21.5-63.9-38.8zm64-22.6c14.9-3.3 30.2-5.3 45.5-6.1V433c-17.2-9.1-33.9-33.9-45.5-67.7zm73.5 67.3v-73.5c15.2.8 30.3 2.8 45 6-11.4 33.6-28 58.3-45 67.5zm45-5.7c10.4-14.6 19.4-33.1 26.5-54.5 13 4.2 25.8 9.5 38 15.6-18.6 17.3-40.6 30.6-64.5 38.9zm83.5-59.8c-16-8.5-32.6-15.5-49.7-21 5.6-23.9 8.9-49.4 9.8-76.1h77.6c-2.7 35.5-15.6 68.9-37.7 97.1z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconGear({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M262.29 192.31a64 64 0 1 0 57.4 57.4a64.13 64.13 0 0 0-57.4-57.4ZM416.39 256a154.34 154.34 0 0 1-1.53 20.79l45.21 35.46a10.81 10.81 0 0 1 2.45 13.75l-42.77 74a10.81 10.81 0 0 1-13.14 4.59l-44.9-18.08a16.11 16.11 0 0 0-15.17 1.75A164.48 164.48 0 0 1 325 400.8a15.94 15.94 0 0 0-8.82 12.14l-6.73 47.89a11.08 11.08 0 0 1-10.68 9.17h-85.54a11.11 11.11 0 0 1-10.69-8.87l-6.72-47.82a16.07 16.07 0 0 0-9-12.22a155.3 155.3 0 0 1-21.46-12.57a16 16 0 0 0-15.11-1.71l-44.89 18.07a10.81 10.81 0 0 1-13.14-4.58l-42.77-74a10.8 10.8 0 0 1 2.45-13.75l38.21-30a16.05 16.05 0 0 0 6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 0 0-6.07-13.94l-38.19-30A10.81 10.81 0 0 1 49.48 186l42.77-74a10.81 10.81 0 0 1 13.14-4.59l44.9 18.08a16.11 16.11 0 0 0 15.17-1.75A164.48 164.48 0 0 1 187 111.2a15.94 15.94 0 0 0 8.82-12.14l6.73-47.89A11.08 11.08 0 0 1 213.23 42h85.54a11.11 11.11 0 0 1 10.69 8.87l6.72 47.82a16.07 16.07 0 0 0 9 12.22a155.3 155.3 0 0 1 21.46 12.57a16 16 0 0 0 15.11 1.71l44.89-18.07a10.81 10.81 0 0 1 13.14 4.58l42.77 74a10.8 10.8 0 0 1-2.45 13.75l-38.21 30a16.05 16.05 0 0 0-6.05 14.08c.33 4.14.55 8.3.55 12.47Z"
      />
    </svg>
  );
}

export function Arrow({ className = "w-5 mr-1" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 23 23" fill="currentColor">
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <path
          d="M13 8L9 12M9 12L13 16M9 12H21M19.4845 7C17.8699 4.58803 15.1204 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.1204 21 17.8699 19.412 19.4845 17"
          stroke="#ffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
}

export function IconElipsis({ className = "w-5" }) {
  return (
    <svg
      className={`${className}`}
      fill="currentColor"
      viewBox="0 0 32 32"
      version="1.1"
    >
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <title>elipsis</title>{" "}
        <path d="M0.384 16q0 1.632 1.12 2.784t2.784 1.12 2.752-1.12 1.152-2.784-1.152-2.752-2.752-1.152-2.784 1.152-1.12 2.752zM12.096 16q0 1.632 1.152 2.784t2.752 1.12 2.752-1.12 1.152-2.784-1.152-2.752-2.752-1.152-2.752 1.152-1.152 2.752zM23.808 16q0 1.632 1.152 2.784t2.752 1.12 2.784-1.12 1.12-2.784-1.12-2.752-2.784-1.152-2.752 1.152-1.152 2.752z"></path>{" "}
      </g>
    </svg>
  );
}

export function IconDocument({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24" fill="none">
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <path
          d="M18.18 8.03933L18.6435 7.57589C19.4113 6.80804 20.6563 6.80804 21.4241 7.57589C22.192 8.34374 22.192 9.58868 21.4241 10.3565L20.9607 10.82M18.18 8.03933C18.18 8.03933 18.238 9.02414 19.1069 9.89309C19.9759 10.762 20.9607 10.82 20.9607 10.82M18.18 8.03933L13.9194 12.2999C13.6308 12.5885 13.4865 12.7328 13.3624 12.8919C13.2161 13.0796 13.0906 13.2827 12.9882 13.4975C12.9014 13.6797 12.8368 13.8732 12.7078 14.2604L12.2946 15.5L12.1609 15.901M20.9607 10.82L16.7001 15.0806C16.4115 15.3692 16.2672 15.5135 16.1081 15.6376C15.9204 15.7839 15.7173 15.9094 15.5025 16.0118C15.3203 16.0986 15.1268 16.1632 14.7396 16.2922L13.5 16.7054L13.099 16.8391M13.099 16.8391L12.6979 16.9728C12.5074 17.0363 12.2973 16.9867 12.1553 16.8447C12.0133 16.7027 11.9637 16.4926 12.0272 16.3021L12.1609 15.901M13.099 16.8391L12.1609 15.901"
          stroke="currentColor"
          strokeWidth="1.5"
        ></path>{" "}
        <path
          d="M8 13H10.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M8 9H14.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M8 17H9.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M19.8284 3.17157C18.6569 2 16.7712 2 13 2H11C7.22876 2 5.34315 2 4.17157 3.17157C3 4.34315 3 6.22876 3 10V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C20.7715 19.8853 20.9554 18.4796 20.9913 16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{" "}
      </g>
    </svg>
  );
}

export function IconMail({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24" fill="currentColor">
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <title></title>{" "}
        <g id="Complete">
          {" "}
          <g id="mail">
            {" "}
            <g>
              {" "}
              <polyline
                fill="none"
                points="4 8.2 12 14.1 20 8.2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              ></polyline>{" "}
              <rect
                fill="none"
                height="14"
                rx="2"
                ry="2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                width="18"
                x="3"
                y="6.5"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
}

export function IconLink({ className = "w-5" }) {
  return (
    <svg className={`${className}`} viewBox="0 0 24 24" fill="none">
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <path
          d="M9.16488 17.6505C8.92513 17.8743 8.73958 18.0241 8.54996 18.1336C7.62175 18.6695 6.47816 18.6695 5.54996 18.1336C5.20791 17.9361 4.87912 17.6073 4.22153 16.9498C3.56394 16.2922 3.23514 15.9634 3.03767 15.6213C2.50177 14.6931 2.50177 13.5495 3.03767 12.6213C3.23514 12.2793 3.56394 11.9505 4.22153 11.2929L7.04996 8.46448C7.70755 7.80689 8.03634 7.47809 8.37838 7.28062C9.30659 6.74472 10.4502 6.74472 11.3784 7.28061C11.7204 7.47809 12.0492 7.80689 12.7068 8.46448C13.3644 9.12207 13.6932 9.45086 13.8907 9.7929C14.4266 10.7211 14.4266 11.8647 13.8907 12.7929C13.7812 12.9825 13.6314 13.1681 13.4075 13.4078M10.5919 10.5922C10.368 10.8319 10.2182 11.0175 10.1087 11.2071C9.57284 12.1353 9.57284 13.2789 10.1087 14.2071C10.3062 14.5492 10.635 14.878 11.2926 15.5355C11.9502 16.1931 12.279 16.5219 12.621 16.7194C13.5492 17.2553 14.6928 17.2553 15.621 16.7194C15.9631 16.5219 16.2919 16.1931 16.9495 15.5355L19.7779 12.7071C20.4355 12.0495 20.7643 11.7207 20.9617 11.3787C21.4976 10.4505 21.4976 9.30689 20.9617 8.37869C20.7643 8.03665 20.4355 7.70785 19.7779 7.05026C19.1203 6.39267 18.7915 6.06388 18.4495 5.8664C17.5212 5.3305 16.3777 5.3305 15.4495 5.8664C15.2598 5.97588 15.0743 6.12571 14.8345 6.34955"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>{" "}
      </g>
    </svg>
  );
}

export function IconChart({ className = "w-5" }) {
  return (
    <svg
      className={`${className}`}
      fill="currentColor"
      viewBox="0 0 32 32"
      version="1.1"
    >
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        {" "}
        <title>chart2</title>{" "}
        <path d="M3.987 4h-0.987v24h26v-0.963l-24.996-0.050-0.017-22.987zM11 5c0-0.553-0.448-1-1-1h-3c-0.553 0-1 0.447-1 1v20h5v-20zM17 11c0-0.553-0.448-1-1-1h-3c-0.553 0-1 0.447-1 1v14h5v-14zM23 17c0-0.553-0.448-1-1-1h-3c-0.553 0-1 0.447-1 1v8h5v-8zM28 22h-3c-0.553 0-1 0.447-1 1v2h5v-2c0-0.553-0.448-1-1-1z"></path>{" "}
      </g>
    </svg>
  );
}

export function IconPdfLine({ className = "w-5" }) {
  return (
    <svg
      className={`${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 58"
    >
      <path d="m50.95 12.187-.771-.771L40.084 1.321 39.313.55A1.891 1.891 0 0 0 37.985 0H8.963C7.777 0 6.5.916 6.5 2.926V56c0 .837.842 1.653 1.838 1.91.05.013.098.032.15.042.156.031.315.048.475.048h40.074c.16 0 .319-.017.475-.048.052-.01.1-.029.15-.042.996-.257 1.838-1.073 1.838-1.91V13.978c0-.767-.092-1.333-.55-1.791zM47.935 12H39.5V3.565L47.935 12zM8.963 56c-.071 0-.135-.026-.198-.049a.458.458 0 0 1-.265-.414V41h41v14.537a.46.46 0 0 1-.265.414c-.063.023-.127.049-.198.049H8.963zM8.5 39V2.926c0-.217.033-.926.463-.926h28.595a1.54 1.54 0 0 0-.058.391V14h11.609c.135 0 .264-.025.39-.058l.001.036V39h-41z" />
      <path d="M22.042 44.744a3.438 3.438 0 0 0-1.128-.615 4.067 4.067 0 0 0-1.271-.205h-2.898V54h1.641v-3.637h1.217c.528 0 1.012-.077 1.449-.232s.811-.374 1.121-.656c.31-.282.551-.631.725-1.046.173-.415.26-.877.26-1.388 0-.483-.103-.918-.308-1.306s-.475-.717-.808-.991zm-.622 3.329c-.101.278-.232.494-.396.649a1.499 1.499 0 0 1-.54.335 1.808 1.808 0 0 1-.595.103h-1.504v-3.992h1.23c.419 0 .756.066 1.012.198.255.132.453.296.595.492.141.196.234.401.28.615a2.8 2.8 0 0 1 .068.567c0 .411-.05.755-.15 1.033zM31.954 45.4c-.424-.446-.957-.805-1.6-1.073s-1.388-.403-2.235-.403h-3.035V54h3.814c.127 0 .323-.016.588-.048.264-.032.556-.104.875-.219.319-.114.649-.285.991-.513s.649-.54.923-.937.499-.889.677-1.477.267-1.297.267-2.126a5.06 5.06 0 0 0-.314-1.757 4.436 4.436 0 0 0-.951-1.523zm-1.196 6.33c-.492.711-1.294 1.066-2.406 1.066h-1.627v-7.629h.957c.784 0 1.422.103 1.914.308s.882.474 1.169.807.48.704.581 1.114c.1.41.15.825.15 1.244 0 1.349-.246 2.38-.738 3.09zM35.598 54h1.668v-4.539h4.211V48.34h-4.211v-3.172H41.9v-1.244h-6.302zM38.428 22.961c-.919 0-2.047.12-3.358.358-1.83-1.942-3.74-4.778-5.088-7.562 1.337-5.629.668-6.426.373-6.802-.314-.4-.757-1.049-1.261-1.049-.211 0-.787.096-1.016.172-.576.192-.886.636-1.134 1.215-.707 1.653.263 4.471 1.261 6.643-.853 3.393-2.284 7.454-3.788 10.75-3.79 1.736-5.803 3.441-5.985 5.068-.066.592.074 1.461 1.115 2.242.285.213.619.326.967.326.875 0 1.759-.67 2.782-2.107.746-1.048 1.547-2.477 2.383-4.251 2.678-1.171 5.991-2.229 8.828-2.822 1.58 1.517 2.995 2.285 4.211 2.285.896 0 1.664-.412 2.22-1.191.579-.811.711-1.537.39-2.16-.385-.749-1.334-1.115-2.9-1.115zm-17.892 9.673c-.468-.359-.441-.601-.431-.692.062-.556.933-1.543 3.07-2.744-1.62 2.992-2.49 3.389-2.639 3.436zm8.2-22.922c.043-.014 1.045 1.101.096 3.216-1.426-1.459-.194-3.183-.096-3.216zm-2.067 16.026a71.291 71.291 0 0 0 2.674-7.564c1.123 2.018 2.472 3.976 3.822 5.544a49.812 49.812 0 0 0-6.496 2.02zm12.901-.479c-.308.431-.976.441-1.21.441-.533 0-.732-.317-1.547-.944a14.395 14.395 0 0 1 1.811-.108c.889 0 1.052.131 1.175.197-.022.071-.08.205-.229.414z" />
    </svg>
  );
}

export function IconImageLine({ className = "w-5" }) {
  return (
    <svg
      className={`${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 58"
    >
      <path d="m50.95 12.187-.771-.771L40.084 1.321 39.313.55A1.891 1.891 0 0 0 37.985 0H8.963C7.777 0 6.5.916 6.5 2.926V56c0 .837.842 1.653 1.838 1.91.05.013.098.032.15.042.156.031.315.048.475.048h40.074c.16 0 .319-.017.475-.048.052-.01.1-.029.15-.042.996-.257 1.838-1.073 1.838-1.91V13.978c0-.767-.092-1.333-.55-1.791zM47.935 12H39.5V3.565L47.935 12zM11.5 2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h.058a1.54 1.54 0 0 0-.058.391V14h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0c0-.02-.01-.037-.011-.057l.01-.002.001.036V26.67l-.163-.155A.975.975 0 0 0 49.5 26a1 1 0 0 0-1-1 .979.979 0 0 0-.557.191l-.648-.615A.974.974 0 0 0 47.5 24a1 1 0 0 0-1-1 .98.98 0 0 0-.618.233l-.627-.596A.988.988 0 0 0 45.5 22a1 1 0 0 0-1-1 .99.99 0 0 0-.68.275l-.607-.577A.993.993 0 0 0 43.5 20a1 1 0 0 0-1-1 .99.99 0 0 0-.73.327l-.581-.552c-.013-.012-.029-.016-.042-.027A.986.986 0 0 0 41.5 18a1 1 0 0 0-2 0c0 .306.145.57.361.753-.031.027-.071.042-.099.073l-.5.548A.986.986 0 0 0 38.5 19a1 1 0 0 0-1 1c0 .344.184.632.448.812l-.613.671A.982.982 0 0 0 36.5 21a.992.992 0 0 0-.444 1.884l-.647.708A.998.998 0 0 0 33.5 24c0 .44.288.802.683.936l-.735.805A.987.987 0 0 0 32.5 25a1 1 0 0 0-1 1c0 .492.362.882.83.966l-.85.931A.992.992 0 0 0 30.5 27a.997.997 0 0 0-.024 1.995l-.509.558-4.743-4.743a1 1 0 0 0-1.355-.055l-6.412 5.457c.016-.07.043-.137.043-.212a1 1 0 1 0-1 1c.015 0 .027-.008.042-.008l-1.063.904A.99.99 0 0 0 14.5 31a1 1 0 0 0-1 1c0 .461.318.832.743.948l-.815.694A.997.997 0 0 0 11.5 34c0 .369.209.678.507.851l-.697.593A.986.986 0 0 0 10.5 35a1 1 0 0 0-1 1c0 .284.121.538.311.72L8.5 37.836V35a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2v-2a1 1 0 0 0 0-2V7a1 1 0 0 0 0-2V3a1 1 0 0 0 1-1h2zM8.963 56c-.071 0-.135-.026-.198-.049a.458.458 0 0 1-.265-.414V41h41v14.537a.46.46 0 0 1-.265.414c-.063.023-.127.049-.198.049H8.963zm1.255-17 14.134-12.03c.051.008.096.03.148.03.025 0 .047-.013.071-.014L34.776 37.19a.999.999 0 1 0 1.414-1.414l-4.807-4.807 9.168-10.041L49.5 29.43V39H10.218z" />
      <path d="M22.042 44.744a3.438 3.438 0 0 0-1.128-.615 4.067 4.067 0 0 0-1.271-.205h-2.898V54h1.641v-3.637h1.217c.528 0 1.012-.077 1.449-.232s.811-.374 1.121-.656c.31-.282.551-.631.725-1.046.173-.415.26-.877.26-1.388 0-.483-.103-.918-.308-1.306s-.475-.717-.808-.991zm-.622 3.329c-.101.278-.232.494-.396.649a1.499 1.499 0 0 1-.54.335 1.808 1.808 0 0 1-.595.103h-1.504v-3.992h1.23c.419 0 .756.066 1.012.198.255.132.453.296.595.492.141.196.234.401.28.615a2.8 2.8 0 0 1 .068.567c0 .411-.05.755-.15 1.033zM30.648 50.869l-3.951-6.945h-1.668V54h1.668v-6.945L30.648 54h1.668V43.924h-1.668zM38.824 49.926h1.709v2.488a.683.683 0 0 1-.342.232 3.29 3.29 0 0 1-.485.13 4.618 4.618 0 0 1-.506.068 5.139 5.139 0 0 1-.403.021c-.328 0-.641-.077-.937-.232-.296-.155-.561-.392-.793-.711s-.415-.729-.547-1.23c-.132-.501-.203-1.094-.212-1.777.009-.702.082-1.294.219-1.777s.326-.877.567-1.183c.241-.306.515-.521.82-.649.305-.128.626-.191.964-.191.301 0 .592.06.875.178.282.118.533.31.752.574l1.135-1.012a3.73 3.73 0 0 0-1.271-.82 4.212 4.212 0 0 0-1.531-.273c-.593 0-1.144.111-1.654.335a3.78 3.78 0 0 0-1.333.978c-.378.429-.675.964-.889 1.606-.214.643-.321 1.388-.321 2.235s.107 1.595.321 2.242c.214.647.51 1.185.889 1.613.378.429.82.752 1.326.971s1.06.328 1.661.328c.301 0 .604-.022.909-.068a4.308 4.308 0 0 0 1.709-.649c.259-.169.494-.385.704-.649v-3.896h-3.336v1.118z" />
      <circle cx="10.5" cy="4" r="1" />
      <circle cx="14.5" cy="4" r="1" />
      <circle cx="18.5" cy="4" r="1" />
      <circle cx="22.5" cy="4" r="1" />
      <circle cx="26.5" cy="4" r="1" />
      <circle cx="30.5" cy="4" r="1" />
      <circle cx="34.5" cy="4" r="1" />
      <circle cx="36.5" cy="6" r="1" />
      <circle cx="32.5" cy="6" r="1" />
      <circle cx="28.5" cy="6" r="1" />
      <circle cx="24.5" cy="6" r="1" />
      <circle cx="20.5" cy="6" r="1" />
      <circle cx="16.5" cy="6" r="1" />
      <circle cx="12.5" cy="6" r="1" />
      <circle cx="10.5" cy="8" r="1" />
      <circle cx="14.5" cy="8" r="1" />
      <circle cx="18.5" cy="8" r="1" />
      <circle cx="22.5" cy="8" r="1" />
      <circle cx="26.5" cy="8" r="1" />
      <circle cx="30.5" cy="8" r="1" />
      <circle cx="34.5" cy="8" r="1" />
      <circle cx="36.5" cy="10" r="1" />
      <circle cx="32.5" cy="10" r="1" />
      <circle cx="28.5" cy="10" r="1" />
      <circle cx="24.5" cy="10" r="1" />
      <circle cx="20.5" cy="10" r="1" />
      <circle cx="16.5" cy="10" r="1" />
      <circle cx="12.5" cy="10" r="1" />
      <circle cx="10.5" cy="12" r="1" />
      <circle cx="22.5" cy="12" r="1" />
      <circle cx="26.5" cy="12" r="1" />
      <circle cx="30.5" cy="12" r="1" />
      <circle cx="34.5" cy="12" r="1" />
      <circle cx="36.5" cy="14" r="1" />
      <circle cx="32.5" cy="14" r="1" />
      <circle cx="28.5" cy="14" r="1" />
      <circle cx="24.5" cy="14" r="1" />
      <circle cx="26.5" cy="16" r="1" />
      <circle cx="30.5" cy="16" r="1" />
      <circle cx="34.5" cy="16" r="1" />
      <circle cx="38.5" cy="16" r="1" />
      <circle cx="42.5" cy="16" r="1" />
      <circle cx="44.5" cy="18" r="1" />
      <circle cx="48.5" cy="22" r="1" />
      <circle cx="46.5" cy="20" r="1" />
      <circle cx="48.5" cy="18" r="1" />
      <circle cx="46.5" cy="16" r="1" />
      <circle cx="36.5" cy="18" r="1" />
      <circle cx="32.5" cy="18" r="1" />
      <circle cx="28.5" cy="18" r="1" />
      <circle cx="24.5" cy="18" r="1" />
      <path d="M10.5 21a.995.995 0 0 0 .928-.644c.136.301.296.589.481.858A.983.983 0 0 0 11.5 22a1 1 0 0 0 1 1 .982.982 0 0 0 .778-.398c.258.184.533.345.822.484A.998.998 0 0 0 14.5 25a1 1 0 0 0 1-1 .978.978 0 0 0-.14-.481 5.56 5.56 0 0 0 2.28 0 .978.978 0 0 0-.14.481 1 1 0 0 0 2 0 1 1 0 0 0-.599-.914 5.59 5.59 0 0 0 .822-.484.979.979 0 0 0 .777.398 1 1 0 0 0 1-1 .98.98 0 0 0-.409-.785 5.58 5.58 0 0 0 .481-.858A.995.995 0 0 0 23.5 20a1 1 0 0 0-1-1 .976.976 0 0 0-.543.182c.073-.36.112-.732.112-1.114 0-.441-.057-.868-.154-1.28A.968.968 0 0 0 22.5 17a1 1 0 0 0 0-2 .988.988 0 0 0-.948.741 5.52 5.52 0 0 0-.53-.909A.986.986 0 0 0 21.5 14a1 1 0 0 0-1-1 .984.984 0 0 0-.839.489 5.512 5.512 0 0 0-.954-.531A.986.986 0 0 0 19.5 12a1 1 0 0 0-2 0c0 .25.101.472.253.647-.404-.093-.822-.147-1.253-.147s-.849.054-1.253.147A.984.984 0 0 0 15.5 12a1 1 0 0 0-2 0c0 .479.344.86.793.958a5.55 5.55 0 0 0-.954.531A.984.984 0 0 0 12.5 13a1 1 0 0 0-1 1c0 .356.197.654.478.832a5.634 5.634 0 0 0-.53.909A.988.988 0 0 0 10.5 15a1 1 0 0 0 0 2 .973.973 0 0 0 .585-.211 5.571 5.571 0 0 0-.154 1.28c0 .381.039.754.112 1.114A.97.97 0 0 0 10.5 19a1 1 0 0 0 0 2zm6-6.5c1.968 0 3.569 1.601 3.569 3.569s-1.601 3.569-3.569 3.569-3.569-1.601-3.569-3.569S14.532 14.5 16.5 14.5z" />
      <circle cx="26.5" cy="20" r="1" />
      <circle cx="30.5" cy="20" r="1" />
      <circle cx="34.5" cy="20" r="1" />
      <circle cx="32.5" cy="22" r="1" />
      <circle cx="28.5" cy="22" r="1" />
      <circle cx="24.5" cy="22" r="1" />
      <circle cx="10.5" cy="24" r="1" />
      <circle cx="22.5" cy="24" r="1" />
      <circle cx="26.5" cy="24" r="1" />
      <circle cx="30.5" cy="24" r="1" />
      <circle cx="28.5" cy="26" r="1" />
      <circle cx="20.5" cy="26" r="1" />
      <circle cx="16.5" cy="26" r="1" />
      <circle cx="12.5" cy="26" r="1" />
      <circle cx="10.5" cy="28" r="1" />
      <circle cx="14.5" cy="28" r="1" />
      <circle cx="18.5" cy="28" r="1" />
      <circle cx="12.5" cy="30" r="1" />
      <circle cx="10.5" cy="32" r="1" />
    </svg>
  );
}
